var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Tag',{staticClass:"TagRemovable"},[_c('span',{staticClass:"label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('Icon',{attrs:{"name":"cross"},on:{"click":function($event){return _vm.$emit('remove')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }